import { render, staticRenderFns } from "./SuccessShared.vue?vue&type=template&id=8927326a"
import script from "./SuccessShared.vue?vue&type=script&lang=js"
export * from "./SuccessShared.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports